"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Typ50 = exports.Typ41 = exports.Typ30 = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const Typ30 = _styledComponents.default.span.withConfig({
  displayName: "Typ30",
  componentId: "sc-1dn99gn-0"
})(["font-size:14px;line-height:20px;font-weight:normal;color:#263238;margin:0;"]);
exports.Typ30 = Typ30;
const Typ41 = _styledComponents.default.span.withConfig({
  displayName: "Typ41",
  componentId: "sc-1dn99gn-1"
})(["font-size:18px;line-height:24px;font-weight:bold;color:#263238;margin:0;"]);
exports.Typ41 = Typ41;
const Typ50 = _styledComponents.default.h4.withConfig({
  displayName: "Typ50",
  componentId: "sc-1dn99gn-2"
})(["font-size:24px;line-height:28px;font-weight:bold;color:#263238;margin:0;"]);
exports.Typ50 = Typ50;
//# sourceMappingURL=typ.js.map